import { message } from 'antd';

export const useFileUpload = () => {
  const handleFileUpload = async (file: File, uploadMutation: any, fileType: string) => {
    let hideLoading: (() => void) | null = null;

    try {
      hideLoading = message.loading(`Uploading ${file.name}...`, 0);
      
      await uploadMutation(file).unwrap();
      message.success(`${file.name} uploaded successfully!`);
    } catch (error: any) {
      const errorMessage = error?.data?.message || error?.message || 'Unknown error';
      message.error(`${file.name} upload failed: ${errorMessage}`);
      throw error;
    } finally {
      if (hideLoading) {
        hideLoading();
      }
    }
  };

  return {
    handleFileUpload,
  };
}; 